import FaqCategoryContainer from './FaqCategoryContainer';
import FaqCategoryStore from './FaqCategoryStore';

export default FaqCategoryStore(FaqCategoryContainer);